import DatabaseModel from './DatabaseModelOffline.js';
import * as DeepDiff from "deep-diff";
import DeepChangesObject from "../DeepChangesObject.js";

var Inspeccion = Object.create(DatabaseModel);

Inspeccion.model = 'inspecciones';

Inspeccion.save = async function (params) {
    var self = this;
    params = params || {};
    // Sin copias profundas: rForm ya entrega `data` y `previousData` como copias propias, y aquí
    // solo se leen (DeepDiff no modifica) o se cambian en su primer nivel (historicoOffline y, en
    // put, _id), que basta con una copia superficial. Cada copia profunda de un expediente de 15 MB
    // eran otros tantos MB en el WebView en cada guardado (cada 45 s).
    const previousDataSnapshot = params.previousData || null;
    const currentDataSnapshot = params.data ? Object.assign({}, params.data) : {};
    let deepChanges = new DeepChangesObject();

    if (previousDataSnapshot) {
        DeepDiff.diff(previousDataSnapshot, currentDataSnapshot, DeepChangesObject.prefiltro, deepChanges);
        // Siempre usar previousDataSnapshot como fuente autoritativa del historicoOffline
        // porque inspeccionInicial (origen de previousData) siempre se actualiza tras cada guardado,
        // mientras que formData (origen de currentData) puede estar desactualizado tras guardados silenciosos.
        // Copia del array, no de sus entradas: el push y el sort de abajo no deben tocar el de
        // previousData, y las entradas no se modifican nunca.
        if (previousDataSnapshot.historicoOffline && Array.isArray(previousDataSnapshot.historicoOffline)) {
            currentDataSnapshot.historicoOffline = previousDataSnapshot.historicoOffline.slice();
        } else if (!currentDataSnapshot.historicoOffline) {
            currentDataSnapshot.historicoOffline = [];
        }
        let changes = await deepChanges.toDatabaseFormat();
        console.log(changes);
        if (changes) {
            currentDataSnapshot.historicoOffline.push(changes);
            console.log('--> fecha del cambio: ' + changes.date);
            // Ordenar por fecha para mantener orden cronologico correcto
            // incluso si las operaciones async terminan en orden diferente
            currentDataSnapshot.historicoOffline.sort((a, b) => {
                return new Date(a.date) - new Date(b.date);
            });
        }
    }

    params.data = currentDataSnapshot;
    if (params.itemId) {
        return self.put(params);
    } else {
        return self.post(params);
    }
};

export default Inspeccion;
